import { useState } from "react"
import { SearchSelect } from "../../shared/searchSelect"
import { SearchFiltersModal } from "../../shared/searchFiltersModal"
import Enums from "../../../utilities/enum"
import { toDateString, toInputFieldDateString } from "../../../utilities/dateUtilities"
import { TagSelector } from "../../shared/tagSelector"
import appliedFiltersUtilities from "../../../utilities/appliedFiltersUtilities"
import arrayUtilities from "../../../utilities/arrayUtilities"

export const ExportBreachesReportFiltersModal = ({
    showModal,
    handleClose,
    handleConfirm,
    initialSingleDate,
    initialSelectedStatus,
    initialSelectedTags = [],
    initialAppliedFilters,
    tags = []
}) => {
    const [singleDate, setSingleDate] = useState(initialSingleDate)
    const [selectedStatus, setSelectedStatus] = useState(initialSelectedStatus)
    const [selectedTags, setSelectedTags] = useState(initialSelectedTags)
    const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

    const handleTagsChange = tagSelections => {
        setSelectedTags(tagSelections)
        setAppliedFilters(prevState => appliedFiltersUtilities.applyMultiSelection(prevState, "Tags", tagSelections, tags))
    }

    const isDateInvalid = singleDate === null || singleDate === ""

    const clearLocalFilters = () => {
        const defaultDate = new Date()
        setSingleDate(defaultDate)
        setSelectedStatus(0)
        setSelectedTags([])
        setAppliedFilters({
            "Date": toDateString(defaultDate),
            "Status": Enums.BreachStatus[0]
        })
    }

    return (
        <SearchFiltersModal
            title="Filter Results"
            handleClose={ handleClose }
            handleConfirm={ () => handleConfirm({ singleDate, selectedStatus, selectedTags, appliedFilters }) }
            showModal={ showModal }
            key="export-breaches-report-filters-modal"
            handleReset={ clearLocalFilters }
            disableConfirm={ isDateInvalid }
        >
            <div className="w-100">
                <div className="mb-2">
                    <label className="m-0 mr-2 mb-1 nowrap">Date</label>
                    <div className="form-group mb-0">
                        <input
                            className="form-control"
                            type="date"
                            value={ toInputFieldDateString(singleDate) }
                            onChange={ e => {
                                const newDate = e.target.value
                                setSingleDate(newDate)
                                if (newDate !== "") {
                                    setAppliedFilters(prevState => ({ ...prevState, "Date": toDateString(new Date(newDate)) }))
                                }
                            } }
                        />
                    </div>
                    { isDateInvalid && <p className="text-danger fs--1 m-0 mt-1">This field cannot be cleared</p> }
                </div>

                <div className="d-flex flex-column mb-2">
                    <label className="m-0 mr-2 mb-1 nowrap">Status</label>
                    <SearchSelect
                        width="100%"
                        options={ Object.entries(Enums.BreachStatus).map(([key, value]) => ({ value: key, label: value })) }
                        onSelect={ value => {
                            setSelectedStatus(Number(value))
                            setAppliedFilters(prevState => ({ ...prevState, "Status": Enums.BreachStatus[value] }))
                        } }
                        selected={ String(selectedStatus) }
                    />
                </div>

                { !arrayUtilities.isNullOrEmpty(tags) && <div className="d-flex flex-column mb-2">
                    <div className="d-flex align-items-center justify-content-between">
                        <label className="m-0 mr-2 mb-1 nowrap">Tags</label>
                        <button onClick={ () => handleTagsChange([]) } className="btn btn-none m-0 p-0 fs--1 mb-1" type="button">Clear tags</button>
                    </div>
                    <TagSelector
                        onChange={ handleTagsChange }
                        selectedTags={ selectedTags }
                        tags={ tags }
                    />
                </div> }
            </div>
        </SearchFiltersModal>
    )
}
